import bTextarea from '../b-textarea/b-textarea.vue'

bTextarea.install = function (Vue) {
  Vue.component(bTextarea.name, bTextarea)
}

export default bTextarea
